import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    annexedContractsDataTable: {
      margin: '0 auto',
      width: '100%'
    },
    form: {},
    card: {
      width: '100%'
    },
    leadFileCard: {
      margin: '0px 8px 16px 8px !important',
      width: '100%'
    },
    leadStateChip: {
      fontWeight: 600
    },
    leadStateChipSinEvaluar: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    leadStateChipEvaluacionSolicitada: {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.getContrastText(theme.palette.warning.main)
    },
    leadStateChipProcesando: {
      backgroundColor: theme.palette.info.main,
      color: theme.palette.getContrastText(theme.palette.info.main)
    },
    leadStateChipEvaluado: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    leadStateChipEvaluacionErronea: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.getContrastText(theme.palette.error.main)
    },
    leadStateChipPublicado: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    }
  })
